import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import { IPeriod } from 'types';

dayjs.extend(isBetween);

export const getDisabledDiapasons = (
  value?: IPeriod[],
) => (
  current: Dayjs,
) => !!value?.some(({ effectiveFrom, effectiveTo }) => current.isBetween(effectiveFrom?.startOf('day'), effectiveTo?.endOf('day'), 'day', '[]'));

export const getFilteredDiapasons = (
  rangePicker: [Dayjs | null, Dayjs | null],
) => (
  value: IPeriod,
) => {
  if (!value.effectiveFrom || !value.effectiveTo || !rangePicker[0] || !rangePicker[1]) {
    return true;
  }

  return value.effectiveFrom.isBetween(rangePicker[0], rangePicker[1], 'day', '[]') || value.effectiveTo.isBetween(rangePicker[0], rangePicker[1], 'day', '[]');
};
